import { isEntityAllowedAsCopySource } from "@common/helpers/chartOfAccountsTemplateApplicability";
import type { WorkspaceSchema } from "@common/schemas/workspace.schema";
import type { AddClientMode } from "../../AddClientSteps/lib";

export type CopySourceEntity = WorkspaceSchema["entities"][number];

interface FilterCopySourceEntitiesParams {
    entities: CopySourceEntity[];
    isGlFirstEnabled: boolean;
}

export function filterCopySourceEntities({
    entities,
    isGlFirstEnabled,
}: FilterCopySourceEntitiesParams): CopySourceEntity[] {
    return entities.filter((sourceEntity) =>
        isEntityAllowedAsCopySource({
            sourceEntity,
            targetWorkspace: { isGlFirstEnabled },
        }),
    );
}

interface CoaSetupTileVisibilityParams {
    mode: AddClientMode;
    isOrganizationWorkspace: boolean;
    canEditCoa: boolean;
    hasCopySourceEntities: boolean;
    areCopySourcesFetched: boolean;
}

export interface CoaSetupTileVisibility {
    isTemplateTileVisible: boolean;
    isEntityTileVisible: boolean;
}

export function getCoaSetupTileVisibility({
    mode,
    isOrganizationWorkspace,
    canEditCoa,
    hasCopySourceEntities,
    areCopySourcesFetched,
}: CoaSetupTileVisibilityParams): CoaSetupTileVisibility {
    if (mode === "newClient") {
        return {
            isTemplateTileVisible: true,
            isEntityTileVisible: false,
        };
    }

    return {
        isTemplateTileVisible:
            !areCopySourcesFetched || isOrganizationWorkspace,
        isEntityTileVisible:
            !areCopySourcesFetched || (canEditCoa && hasCopySourceEntities),
    };
}
